import 'assets/style/custom.css';

import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';

import Layout from 'routes/Layout';
import LoaderProvider from 'commons/contexts/LoaderProvider';
import configureStore from 'store/configureStore';
import LoadingProvider from 'context/LoaderProvider';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

function App() {
    return (
        <LoadingProvider>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <LoaderProvider>
                        <ChakraProvider>
                            <Layout />
                        </ChakraProvider>
                    </LoaderProvider>
                </ConnectedRouter>
            </Provider>
        </LoadingProvider>
    );
}

export default App;
